import { SubscriptionSettings } from "@/components/SubscriptionSettings";
import DefaultLayout from "@/layout/default-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/subscription")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { checkout?: "success" | "canceled" } => ({
    checkout:
      search.checkout === "success" || search.checkout === "canceled"
        ? search.checkout
        : undefined,
  }),
  component: SubscriptionPage,
});

function SubscriptionPage() {
  const { checkout } = Route.useSearch();
  return (
    <DefaultLayout>
      <SubscriptionSettings checkout={checkout} />
    </DefaultLayout>
  );
}
